// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap'); */

body {
  font-family: "Inter", sans-serif;
  /* background-color: #f3f6f9; */
  background: #f4f6f9;
}

a {
  color: inherit;
}

.suspenece-spin {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.ant-form-item .ant-form-item-label>label {
  font-size: 0.87rem;
  color: #344054;
}

.ant-form-item .ant-form-item-explain,
.ant-form-item .ant-form-item-extra {
  font-size: 0.87rem;
}

.ant-upload-drag-container .ri-upload-cloud-2-fill {
  font-size: 24px;
  color: #9a9fb8;
}

.ant-card-contain-grid {
  border-radius: 10px;
}

.ant-card .ant-card-grid-hoverable:hover {
  position: relative;
  z-index: 0;
  box-shadow: none;
}

.font-14 {
  font-size: 14px !important;
}

.font-16 {
  font-size: 16px;
}

.font-18 {
  font-size: 18px;
}

.font-22 {
  font-size: 22px;
  font-weight: 600;
}

.fontW600 {
  font-weight: 600;
}

.text-blue {
  color: rgba(26, 55, 96, 0.88);
}

/* .ant-input {
  padding: 9px 14px;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
}
.ant-input.ant-input-sm {
  padding: 4px 8px;
}
.ant-input::placeholder,
.ant-select .ant-select-selection-placeholder {
  color: #667085;
} */
.ant-layout {
  background: transparent;
}

.ant-layout main {
  padding: 40px;
}

.ant-layout-sider {
  height: max-content;
  min-height: 100vh;
  border-right: 1px solid #eaecf0;
  padding: 30px 20px;
  position: sticky !important;
  top: 0;
}

.anychart-credits {
  display: none;
}

/* .ant-menu-inline .ant-menu-item {
  height: 40px;
  line-height: 40px;
} */
.ant-menu {
  font-size: 14px;
  padding: 16px 12px;
}

.ant-menu-light.ant-menu-root.ant-menu-inline,
.ant-menu-light.ant-menu-root.ant-menu-vertical {
  border: none;
}

.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title,
.ant-menu-vertical .ant-menu-submenu-title {
  padding-inline: 16px !important;
}

.ant-menu .ant-menu-item .ant-menu-item-icon+span,
.ant-menu .ant-menu-submenu-title .ant-menu-item-icon+span,
.ant-menu .ant-menu-item .anticon+span,
.ant-menu .ant-menu-submenu-title .anticon+span {
  margin-left: 8px;
}

.ant-layout-sider .ant-menu-item {
  margin-block: 2px !important;
  height: 30px !important;
}

.ant-layout-sider .ant-menu-item-group-title {
  padding: 6px 16px;
}

/* .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item {
  padding: 8px 12px;
} */
.ant-message-notice {
  text-align: right;
  padding-right: 25px;
  padding-top: 15px;
}

/* .ant-btn {
  display: inline-flex;
  padding: 10px 18px;
  align-items: center;
  justify-content: center;
} */
.ant-btn-primary {
  box-shadow: 0 2px 2px rgb(1 9 14 / 15%);
}

.ant-table-cell-product+.ant-table-cell-product {
  border-top: 1px solid #e8e8e8;
}

.ant-table-cell .ant-btn {
  height: auto;
  font-size: 12px;
  padding: 4px 10px;
  /* padding: 0px 8px; */
  border-radius: 6px;
}

/* .ant-table-cell a:hover {
  text-decoration: underline;
} */

.ant-btn [class^="ri-"],
.ant-btn [class*=" ri-"] {
  display: inline-block;
  margin-right: 3px;
}

.ant-btn.ant-btn-sm {
  font-size: 12px;
  height: 30px;
}

.ant-input-affix-wrapper .ant-input-prefix {
  margin-right: 12px;
  color: #667085;
}

.ant-table-wrapper:not(.table-inner) .ant-table {
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  overflow: auto;
}

.ant-table-wrapper.table-inside-card .ant-table {
  border: none;
  box-shadow: none;
  /* border-radius: 0; */
  margin-top: 1px;
  border-start-start-radius: 0;
  border-start-end-radius: 0;
}

.ant-table-wrapper.table-inside-card .ant-table-container table>thead>tr:first-child>*:first-child {
  border-start-start-radius: 0;
}

.ant-table-wrapper.table-inside-card .ant-table-container table>thead>tr:first-child>*:last-child {
  border-start-end-radius: 0;
}

.table-inside-card .ant-table-cell {
  padding: 8px 12px !important;
}

.expand-warehouse-table .ant-table {
  border: none !important;
  box-shadow: none !important;
}

.profile-details-card {
  border: 1px solid #e8e8e8 !important;
}

.profile-details-card .ant-card-body {
  /* padding: 2rem 2.25rem; */
  border-radius: 12px;
}

.profile-details-card .ant-card-body .title {
  color: #030229;
  font-weight: 500;
  /* font-size: 16px; */
}

.status-tag {
  padding: 4px 10px;
  font-size: 0.8rem;
  font-weight: normal;
}

.profile-details-card .details {
  color: #030229;
  font-weight: 400;
  /* font-size: 16px; */
}

.title {
  color: rgba(26, 55, 96, 0.88);
  font-weight: 600;
  /* font-size: 16px; */
}

.details {
  color: #99a1b7;
  font-weight: 500;
  font-size: 14px;
}

.text-030229 {
  color: #030229;
}

.text-03022903 {
  color: #0302294d;
}

.card-title-custom .ant-card-head-title {
  /* color: #030229; */
  font-size: 14px;
  font-weight: 600;
}

.card-title-custom .ant-card-body {
  border-radius: 12px;
}

.card-title-custom .ant-card {
  border: 1px solid #e8e8e8;
}

.card-title-custom {
  /* padding: 13px; */
  border-radius: 12px;
  border: 1px solid #e8e8e8 !important;
}

.ant-tabs-tab-btn {
  /* font-size: 16px; */
  color: rgba(26, 55, 96, 0.88);
}

.tabs-custom .status-icon-box {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabs-custom .vendor-po-title {
  color: #4f4e6a;
  font-weight: 700;
  font-size: 16px;
  line-height: 2rem;
  margin-bottom: 0;
}

.tabs-custom .vendor-po-desc {
  color: #4f4e6a;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5rem;
}

.background-5B93FF {
  background-color: #eff4ff;
}

.background-FFF7E1 {
  background-color: #ffd56b3f;
}

.background-FFFBF9 {
  background-color: #ff906b3a;
}

.border-bottom {
  border-bottom: 0.5px solid #03022919;
}

/* customer details css end */
.ant-row {
  width: 100%;
}

.ant-steps-vertical .ant-steps-item {
  padding-bottom: 50px;
}

.mt40 {
  margin-top: 40px !important;
}

.mt6 {
  margin-top: 6px;
}

.mt8 {
  margin-top: 8px;
}

.mt10 {
  margin-top: 10px;
}

.mt16 {
  margin-top: 16px;
}

.mt20 {
  margin-top: 20px;
}

.mt24 {
  margin-top: 24px;
}

.mt30 {
  margin-top: 30px;
}

.mt-2 {
  margin-top: 2px;
}

.mb-9 {
  margin-bottom: 9px;
}

.mb0 {
  margin-bottom: 0 !important;
}

.mb28 {
  margin-bottom: 28px;
}

.mb24 {
  margin-bottom: 24px;
}

.mb16 {
  margin-bottom: 16px;
}

.mb8 {
  margin-bottom: 8px;
}

.mb2 {
  margin-bottom: 2px;
}

.me4 {
  margin-right: 12px;
}

.me1 {
  margin-right: 4px;
}

.my10 {
  margin: 10px 0;
}

.mx16 {
  margin: 0 16px;
}

.mx26 {
  margin: 0 26px;
}

.pt10 {
  padding-top: 10px;
}

.pb16 {
  padding-bottom: 16px;
}

.pb24 {
  padding-bottom: 24px;
}

.p-4 {
  padding: 4px;
}

.borderBottomDotted {
  border-bottom: 1px dotted;
}

.linkHover:hover {
  text-decoration: underline;
}

.borderBottom-ebebeb {
  border-bottom: 1px solid #ebebeb;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.text-center {
  text-align: center;
}

.fontWeight600 {
  font-weight: 600;
}

.text-right {
  text-align: right;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-between {
  justify-content: space-between;
}

.d-none {
  display: none;
}

.d-block {
  display: block;
}

.underline {
  text-decoration: underline;
}

.height-100 {
  height: 100%;
}

.grid {
  display: grid;
}

.grid-cols-4 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.gap30 {
  gap: 30px;
}

.mandatory-sign-mark::after {
  display: inline-block;
  margin-inline-end: 4px;
  color: #ff4d4f;
  font-size: 13px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
  margin-left: 4px;
}

.login-container {
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #fafafa;
  align-items: center;
  /* background-color: #a099ff;
  background-image: radial-gradient(at 48% 74%,
      hsla(253, 90%, 67%, 1) 0px,
      transparent 50%),
    radial-gradient(at 85% 24%, hsla(269, 76%, 75%, 1) 0px, transparent 50%),
    radial-gradient(at 55% 58%, hsla(39, 62%, 65%, 1) 0px, transparent 50%),
    radial-gradient(at 85% 4%, hsla(262, 88%, 74%, 1) 0px, transparent 50%),
    radial-gradient(at 10% 1%, hsla(184, 84%, 60%, 1) 0px, transparent 50%),
    radial-gradient(at 39% 5%, hsla(13, 83%, 78%, 1) 0px, transparent 50%),
    radial-gradient(at 51% 9%, hsla(288, 71%, 77%, 1) 0px, transparent 50%); */
}

.login-card {
  width: 100%;
  margin-top: 50px;
  border: 1px solid #e3e6e9;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
}

.login-card .logo {
  width: 180px;
}

.sidebar-custom-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.sidebar-custom-wrap .ant-menu {
  margin-top: 16px;
}
  

.header-user-card-container {
  border-radius: 6px;

  padding: 5px 10px;
}

.header-user-card {
  /* border: 1px solid #d0d5dd;  */
  border-radius: 8px;
  /* padding: 10px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.user-details {
  max-width: 110px;
}

.user-details-wrap {
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;
  align-items: center;
}

.user-details-name {
  font-size: 12px;
  /* color: #1a3760; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
}

.user-details-email {
  font-size: 10px;
  /* color: #1a3760; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.page-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  /* padding-left: 16px;
  padding-right: 16px; */
  /* padding-left: 8px;
  padding-right: 10px; */
  padding-left: 7px;
  padding-right: 17px;
  gap: 16px;
}

.page-header-wrapper .page-header-title {
  font-size: 24px;
  font-weight: bold;
  text-wrap: nowrap;
}

.page-header-wrapper .page-header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 350px;
}

.card-checkbox .ant-checkbox-wrapper {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  padding: 15px 28px 15px 10px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
}

.card-checkbox .ant-checkbox-wrapper .ant-checkbox {
  position: absolute;
  top: 5px;
  right: 5px;
}

.card-checkbox .ant-checkbox-wrapper .ant-checkbox .ant-checkbox-inner,
.card-checkbox .ant-checkbox-checked:after {
  border-radius: 100%;
}

.card-checkbox .ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-checked) .ant-checkbox-inner {
  border-color: transparent;
}

.card-checkbox .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {
  background-color: #e6f4ff;
  border-color: #1677ff;
  border-width: 2px;
  padding: 14px 27px 14px 9px;
  /* border-width: 2px; */
}

.report_type_checkboxes .ant-checkbox-wrapper {
  padding: 15px 28px 15px 28px;
}

.report_type_checkboxes .ant-checkbox+span {
  width: 100%;
  text-align: center;
}

.report_type_checkboxes .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {
  padding: 14px 27px 14px 27px;
}

.marketplace-region {
  color: #8996a9;
}

.antd-table-filter-dropdown {
  padding: 15px 10px;
  min-width: 200px;
  display: flex;
  justify-content: center;
}

.appplied-filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

.applied-filter-tag {
  font-size: 10px;
  font-weight: 400;
}

.applied-filter-value {
  font-size: 10px;
  font-weight: 700;
}

.applied-filters-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  flex-grow: 1;
}

.applied-filter-wrap {
  padding: 8px;
  background-color: #ffffff;
  color: #132237;
  border-radius: 8px;
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;
  height: auto;
  border: 1px solid #e3e6e9;
}

.applied-filter-wrap>span {
  cursor: pointer;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.applied-filter {
  font-weight: bold;
}

.applied-filter>span {
  font-size: 10px;
  font-weight: normal;
  margin-right: 10px;
}

.applied-filter-wrap .applied-filter-remove {
  display: flex;
  align-items: flex-start;
  margin-left: 5px;
  cursor: pointer;
}

.detail-block {
  line-break: anywhere;
}

.detail-block>label,
.detail-block>span {
  display: block;
}

.detail-block>label {
  font-size: 14px;
  color: #667085;
  margin-bottom: 3px;
}

.detail-block>span {
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
}

.marketplace-detail-card,
.report-type-wrapper {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  padding: 15px 28px 15px 10px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
  position: relative;
  font-weight: normal;
  text-align: center;
}

.report-type-wrapper {
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 18px 20px;
  width: 100%;
  white-space: nowrap;
}

.table-tag .ant-alert {
  display: inline-flex;
  padding: 4px 8px;
}

.table-tag .ant-alert .ant-alert-content {
  font-size: 12px;
}

.product-image-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.product-image-wrapper {
  width: 102px;
  height: 102px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
}

.product-image-wrapper-sm {
  width: 50px;
  height: 50px;
  padding: 5px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
}

.product-title {
  font-size: 16px;
}

.product-price {
  color: #1677ff;
}

.detail-block>label {
  /* font-weight: 600; */
}

.detail-block ul {
  padding-inline-start: 16px;
  list-style-type: decimal;
}

.detail-block ul li {
  font-size: 18px;
  font-weight: bold;
}

.pd-identifier {
  color: #667085;
  margin-bottom: 10px;
  display: block;
}

.pd-product-name {
  font-weight: bold;
  font-size: 20px;
}

.ant-descriptions-item-content ul {
  padding-left: 18px;
}

.pd-status-wrap {
  display: inline-block;
  margin-bottom: 20px;
}

.amazon-serach-modal-search .ant-input-group .ant-input-group-addon .ant-select {
  margin: 0;
  border: 1px solid #d9d9d9;
  border-radius: 8px 0 0 8px;
  border-right: 0px;
}

.amazon-serach-modal-search .ant-input-group .ant-input-group-addon {
  padding: 0;
  border: 0;
}

.amazon-serach-modal-search .ant-input-group .ant-input {
  height: 46px;
}

.amazon-serach-modal-search .ant-input-group .ant-input-group-addon .ant-btn {
  border-radius: 0 8px 8px 0;
  border-left: 0;
  height: 46px;
}

.read-more-btn {
  background-color: transparent;
  border: none;
  color: #8996a9;
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.w-100 {
  width: 100%;
}

@media all and (min-width: 576px) {
  .login-card {
    width: 480px;
    padding: 40px;
    padding-bottom: 60px;
  }
}

.ant-checkbox-wrapper {
  align-items: center;
}

.ant-form-item-required::before {
  order: 1;
  margin-right: 0;
  margin-left: 4px;
}

.ant-list-bordered {
  overflow: hidden;
}

.prdouct-info-btn {
  display: flex;
  justify-content: flex-end;
}

.password-field label {
  width: 100%;
}

.password-field .password-field-label {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ant-form-item .ant-form-item-label>label::after {
  display: none;
}

.password-field .ant-form-item-extra {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateY(-100%);
}

.ant-layout .ant-layout-sider-light {
  /* background-color: #ffffff; */
  background-color: #001529;
  padding: 0;
  /* border: 0; */
}

.ant-drawer-body, .ant-drawer-header {
   background-color: #001529;
}

.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper,
.ant-layout-header {
  height: 56px;
}

.ant-layout-header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  line-height: 1.25;
  padding: 0 16px;
  z-index: 1;
  border-bottom: 1px solid #eaecf0;
}

.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper {
  padding: 5px 16px;
}

.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper img {
  max-height: 100%;
  margin: 0;
}

.ant-layout-sider .ant-menu-item {
  font-weight: 500;
}

.ant-pagination .ant-pagination-item {
  border-radius: 6px;
}

.ant-card {
  box-shadow: rgba(26, 26, 26, 0.07) 0px 1px 0px 0px;
  border: 1px solid rgb(204, 204, 204, 0.5);
}

.ant-picker {
  width: 100%;
}

.ant-list-bordered {
  background-color: #fff;
}

.address-make-default-btn {
  opacity: 0;
  transition-duration: 0.3s;
}

.ant-collapse-header:hover .address-make-default-btn {
  opacity: 1;
}

.ant-upload-list {
  margin-top: 8px;
}

.ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item-container,
.ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload.ant-upload-select {
  width: 80px;
  height: 80px;
}

.ant-upload-wrapper .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item {
  border-radius: 8px;
  padding: 6px;
}

.ant-upload-wrapper .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item .ant-upload-list-item-thumbnail {
  border-radius: 4px;
}

.ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item::before {
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  top: 0;
  left: 0;
  border-radius: 6px;
}

.ant-upload-wrapper .ant-upload-list .ant-upload-list-item .ant-upload-list-item-actions .ant-upload-list-item-action.ant-btn-sm {
  padding: 10px 5px;
  width: auto;
  height: auto;
  background-color: #ffffff29;
  border: 1px solid #ffffff50;
}

.ant-menu-sub.ant-menu-inline .ant-menu-item {
  padding-left: 38px !important;
}

.form-remove-btn {
  margin-top: 32px;
  font-size: 18px;
}

.ql-toolbar.ql-snow {
  border-radius: 8px 8px 0 0;
  padding: 5px 3px;
  font-family: "Inter", sans-serif;
}

.ql-toolbar.ql-snow .ql-picker-label {
  border-radius: 5px;
}

.ql-toolbar.ql-snow .ql-picker-options {
  border-radius: 8px;
}

.ql-container {
  font-family: "Inter", sans-serif;
}

.ql-container.ql-snow {
  border-radius: 0 0 8px 8px;
}

.ql-editor {
  min-height: 5rem;
  max-height: 30rem;
  overflow-y: auto;
}

.hamburger-responsive {
  /* border: 1px solid #4c535e; */
  background-color: #2b2f35;
  height: 37px;
  width: 37px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.nav-logo-responsive {
  /* max-height: 37px; */
  width: auto;
}

.form-tab-section {
  margin: 24px 0px;
}

.form-tab-section .ant-tabs-nav {
  margin-bottom: 0px;
  /* z-index: 1; */
  /* border-bottom: 1px solid rgb(204, 204, 204, 0.5); */
}

.form-tab-section .ant-tabs-tabpane>.ant-card {
  background: transparent;
  border-top-right-radius: 0%;
  border-top-left-radius: 0%;
  /* border-top: none; */
  position: relative;
  /* z-index: -1; */
}

.form-tab-section .ant-tabs-tab-active {
  background: #f3f6f9 !important;
  border: 1px solid rgb(204, 204, 204, 0.5) !important;
  border-bottom: none !important;
}

.form-tab-section .ant-tabs-nav {
  position: sticky;
  top: 56px;
}

.form-tab-section .ant-tabs-top>.ant-tabs-nav::before {
  border-bottom-color: rgb(204, 204, 204, 0.5);
}

.form-tab-section .ant-tabs-nav-wrap {
  background: #f3f6f9;
}

.form-tab-section .ant-tabs-tab-active::after {
  position: absolute;
  right: 0;
  left: 0;
  bottom: -4px;
  /* border-bottom: 3px solid #172539; */
  border: 3px solid #f3f6f9;
  content: "";
  /* z-index: 2; */
}

.header-user-card-container {
  cursor: pointer;
}

.ant-menu-sub .ant-menu-item {
  height: 28px;
  line-height: 28px;
}

/* .ant-menu-submenu-open {
  background-color: rgba(229, 240, 255, 0.5);
} */

.ant-menu-submenu-open {
  background-color: #ebeff480;
}

.ant-menu-inline-collapsed .ant-menu-item-group-title {
  opacity: 0;
  /* height: ; */
}

.ant-menu-item-group:not(:first-child) {
  margin-top: 0px;
}

.sidebar-responsive {
  font-size: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  padding: 0;
  border: 1px solid #eee;
}

.ant-menu-light.ant-menu-root.ant-menu-inline {
  overflow-y: auto;
}

.table-cell-link {
  font-weight: 700;
}

/* .table-cell-link:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
} */

/* .table-cell-product-image {
  border: 1px solid rgba(235, 235, 235, 1);
  min-height: 40px;
  min-width: 40px;
  object-fit: cover;
  border-radius: 6px;
} */

.table-cell-product-image {
  border: 1px solid rgba(235, 235, 235, 1);
  min-height: 40px;
  min-width: 40px;
  object-fit: contain;
  border-radius: 6px;
  aspect-ratio: 1 / 1;
}

.ant-table-cell-with-append {
  /* display: flex; */
  align-items: center;
}

.ant-table-wrapper:not(.table-inner) .ant-table-row-indent+.ant-table-row-expand-icon {
  border-color: #1a3760e0;
  margin-top: 12px;
}

.ant-table-wrapper.expand-without-image .ant-table-row-indent+.ant-table-row-expand-icon {
  display: none;
}

.ant-tabs-card>.ant-tabs-nav .ant-tabs-tab {
  background: rgb(26 55 96 / 7%);
  border: none;
}

.ant-tabs>.ant-tabs-nav .ant-tabs-nav-add {
  border: none;
  background: rgb(26 55 96 / 7%);
}

.purchase-order-table {
  margin-top: 12px;
}

.purchase-order-table.ant-table-wrapper .ant-table {
  border: none;
  box-shadow: none;
  border-radius: 0;
}

.purchase-order-table.ant-table-wrapper .ant-table-container,
.purchase-order-table.ant-table-wrapper .ant-table-container table,
.purchase-order-table.ant-table-wrapper .ant-table-container table>thead>tr:first-child>*:first-child,
.purchase-order-table.ant-table-wrapper .ant-table-container table>thead>tr:first-child>*:last-child {
  border-radius: 0;
}

.purchase-order-table .ant-table-cell {
  vertical-align: top;
}

.recieve-order-progress .ant-progress .ant-progress-success-bg {
  background-color: rgba(41, 132, 90, 1);
}

.recieve-order-progress .ant-progress-bg {
  background-color: rgba(181, 38, 11, 1);
}

.inventory-unavaible-card .ant-card-body {
  padding: 4px;
}

.inventory-unavaible-card .ant-card-head {
  padding: 4px;
  min-height: auto;
}

.order-user-card .ant-card {
  border: 0px;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.order-user-card .ant-card:hover {
  border: 0px;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.order-user-card .ant-card .ant-card-body {
  padding: 8px;
  border-radius: 0;
}

.order-user-link-card .ant-card {
  border: 0px;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.order-user-link-card .ant-card:hover {
  border: 0px;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.order-user-link-card .ant-card .ant-card-body {
  padding: 8px;
  border-radius: 0;
}

.collection-product-table .ant-table-container .ant-table-thead {
  display: none;
}

.collection-product-table {
  margin-top: 24px;
}

.product-variant-badge .ant-badge.ant-badge-status .ant-badge-status-dot {
  width: 6px;
  height: 6px;
}

.comment-section .comment-section-input {
  border: none;
  padding-left: 0;
}

.comment-section .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus,
.comment-section .ant-input:focus {
  box-shadow: none;
}

.comment-section .ant-card-small>.ant-card-body {
  padding: 0;
}

.comment-section .comment-section-top {
  padding: 12px;
}

.comment-section .comment-section-bottom {
  padding: 12px;
  background-color: #f3f6f9;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.comment-section-block {
  position: absolute;
  inset-block-start: 0px;
  inset-inline-start: 4px;
  height: 40px;
  border-inline-start: 2px solid rgba(5, 5, 5, 0.06);
}

.log-inventory_received .ant-table-wrapper:not(.table-inner) .ant-table {
  border: none;
  box-shadow: none;
  border-radius: 0px;
  overflow: auto;
}

.log-inventory_received .ant-table-wrapper .ant-table-thead>tr>th,
.log-inventory_received .ant-table-wrapper .ant-table-thead>tr>td {
  position: relative;
  color: rgba(26, 55, 96, 0.88);
  font-weight: 600;
  text-align: start;
  background: transparent;
  border-bottom: none;
}

.log-inventory_received .ant-table-wrapper .ant-table {
  background: transparent;
}

.log-inventory_received .ant-table-wrapper .ant-table-tbody>tr>td {
  border-bottom: none;
}

.log-inventory_received .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  background-color: transparent;
}

.log-inventory_received .log-inventory_received-description:hover {
  text-decoration: underline;
  cursor: pointer;
}

.log-inventory_received .log-inventory_received-arrow:hover {
  cursor: pointer;
}

.log-inventory_received .log-inventory_received-description-container {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.mt3 {
  margin-top: 3px;
}

/* cms page form css start */
.dashed-border {
  /* border:1px dashed #8996a9; */
  margin-top: 20px;

  border-top: 1px dashed #8996a9;
}

.form-title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}

.form-description {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}

.form-box {
  background-color: white;
  padding: 32px;
}

/* cms page form css end */

/* sticky footer css start */
.sticky-footer {
  position: sticky;
  bottom: 0;
  backdrop-filter: blur(9px);
  background-color: rgba(243, 244, 246, 0.1);
  text-align: right;
  padding-left: 2rem;
  padding-right: 2rem;
  margin-left: -2rem;
  margin-right: -2rem;
  z-index: 999;
}

.sticky-footer-padding {
  position: sticky;
  bottom: 0;
  backdrop-filter: blur(9px);
  background-color: rgba(243, 244, 246, 0.1);
  text-align: right;
  padding: 1.5rem 3.2rem;
  /* padding-left: 2rem;
  padding-right: 2rem; */
  margin-left: -2rem;
  margin-right: -2rem;
}

.ant-card .ant-card-actions>li {
  margin: 4px 0;
}

.ant-card .ant-card-head-title {
  overflow: visible;
}

.google-places-autocomplete {
  margin-bottom: 24px;
}

.google-places-autocomplete div[class\$="control"]::before {
  width: 24px;
  height: 24px;
  content: "";
  background-image: url("https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg");
  background-size: 24px 24px;
  position: absolute;
  top: 4px;
  left: 4px;
  pointer-events: none;
}

.google-places-autocomplete div[class\$="control"] {
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  border-radius: 8px;
  transition: all 0.2s;
  min-height: 32px;
  height: auto;
  padding-left: 32px;
}

.google-places-autocomplete div[class\$="indicatorContainer"] {
  padding: 6px;
}

.google-places-autocomplete div[class\$="Input"] {
  margin: 0;
}
/* sticky footer css end */

/* filter section start */
.filter-section {
  margin: 16px 0px;
}

.filter-section .ant-card .ant-card-body {
  padding: 4px;
}

.filter-section .ant-btn.ant-btn-sm {
  padding: 5.5px 8px;
}

.filter-section .ant-btn.ant-btn-sm.ant-btn-text {
  padding: 5.5px 12px;
  font-weight: 600;
}

.filter-section-head {
  border-bottom: 1px solid rgb(204, 204, 204, 0.5);
  padding: 10px 10px 10px 10px;
}

/* filter section end */

/* Setting start */
.header-setting .menu-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-setting .menu-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 2rem;
  margin-bottom: 0;
}

.background-ff6b6b3a {
  background-color: #ff8b8b3a;
  color: rgb(235 29 29);
}

.background-6bff6b3a {
  background-color: #80ff803a;
  color: #15b41e;
}
/* Setting end */
 

/* Dashboard Start */
/* .dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.dashboard-header .page-title-wrapper .page-header-title {
  font-size: 20px;
  font-weight: 600;
  color: #111111e0;
  margin-bottom: 6px;
}
.dashboard-header .page-title-wrapper .page-header-description {
  font-size: 12px;
  font-weight: 400;
  color: #00000073;
} */

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;

  .page-title-wrapper {
    .page-header-title {
      font-size: 20px;
      font-weight: 600;
      color: #111111e0;
      margin-bottom: 6px;
    }

    .page-header-description {
      font-size: 12px;
      font-weight: 400;
      color: #00000073;
    }
  }

  .dashboard-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 12px;
  }
}

.dashboard-header .ant-select,
.dashboard-header .ant-picker {
  min-width: 120px;
  max-width: 240px;
}

@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    align-items: flex-start;

    .dashboard-filters {
      width: 100%;
      justify-content: flex-start;
    }
  }
}

.creative-gallery {
  display: flex;
  gap: 8px;
  /* flex-wrap: wrap; */
  align-items: center;
}

.creative-img {
  border:1px solid #ebebeb;
  border-radius: 12px;
  object-fit: cover;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.creative-img:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.map-header {
  position: absolute;
  z-index: 1;
  background: #fff;
  padding: 0px 12px 8px 0px;
  border-bottom-right-radius: 10px;
  top: 16px;
}


.dashboard-container .ant-table-wrapper:not(.table-inner) .ant-table {
  border: 0px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  overflow: auto;
}

.highlighted-row {
  background-color: #e6f7ff !important;
  transition: background-color 0.3s ease;
}

.gm-style-iw-chr {
 display: none !important;
}

.ant-image-preview-switch-right,
.ant-image-preview-switch-left,
.ant-image-preview-close {
    color: #001529;
    background: #ffffff;
}

.ant-image-mask-info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

/* .ant-image-mask-info::after {
  content: none !important;
}

.ant-image-mask-info > span + span {
  display: none !important;
} */

.brand-scroll-container::-webkit-scrollbar {
  height: 5px; /* Smaller height for horizontal scroll */
}

.brand-scroll-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.brand-scroll-container::-webkit-scrollbar-track {
  background: #f0f0f0;
}


/* Dashboard End */

@media all and (min-width: 1200px) {
  .header-user-card-container {
    min-width: 180px;
    background-color: #f7f7f7;
  }
}

@media all and (max-width: 1200px) {
  .nav-logo-responsive {
    max-height: 50px;
    width: auto;
  }
}

@media all and (max-width: 767px) {
  .search-wrapper {
    min-width: 300px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,8FAA8F;;AAE9F;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;GAWG;AACH;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,2BAA2B;EAC3B,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;;;GAGG;AACH;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;GAEG;AACH;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;GAKG;AACH;EACE,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;;EAEE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB;;;;;;;;;8EAS4E;AAC9E;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;;EAElB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB;wBACsB;EACtB;wBACsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,UAAU;EACV,eAAe;AACjB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,MAAM;EACN,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,oDAAoD;EACpD,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;;;;;;GAMG;;AAEH;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,+BAA+B;EAC/B,gBAAgB;;EAEhB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA,0BAA0B;;AAE1B,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,0CAA0C;EAC1C,iBAAiB;EACjB,sBAAsB;EACtB;wBACsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oGAAoG;EACpG,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;AACA,0BAA0B;;AAE1B,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA,uBAAuB;;AAEvB,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA,gBAAgB;;;AAGhB,oBAAoB;AACpB;;;;;;;;;;;;;;;;GAgBG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;;EAEf;IACE;MACE,eAAe;MACf,gBAAgB;MAChB,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,gBAAgB;MAChB,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;;IAEvB;MACE,WAAW;MACX,2BAA2B;IAC7B;EACF;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,SAAS;AACX;;;AAGA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;;IAGI,cAAc;IACd,mBAAmB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;;;;GAMG;;AAEH;EACE,WAAW,EAAE,yCAAyC;AACxD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,kBAAkB;;AAElB;EACE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap'); */\n\nbody {\n  font-family: \"Inter\", sans-serif;\n  /* background-color: #f3f6f9; */\n  background: #f4f6f9;\n}\n\na {\n  color: inherit;\n}\n\n.suspenece-spin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.ant-form-item .ant-form-item-label>label {\n  font-size: 0.87rem;\n  color: #344054;\n}\n\n.ant-form-item .ant-form-item-explain,\n.ant-form-item .ant-form-item-extra {\n  font-size: 0.87rem;\n}\n\n.ant-upload-drag-container .ri-upload-cloud-2-fill {\n  font-size: 24px;\n  color: #9a9fb8;\n}\n\n.ant-card-contain-grid {\n  border-radius: 10px;\n}\n\n.ant-card .ant-card-grid-hoverable:hover {\n  position: relative;\n  z-index: 0;\n  box-shadow: none;\n}\n\n.font-14 {\n  font-size: 14px !important;\n}\n\n.font-16 {\n  font-size: 16px;\n}\n\n.font-18 {\n  font-size: 18px;\n}\n\n.font-22 {\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.fontW600 {\n  font-weight: 600;\n}\n\n.text-blue {\n  color: rgba(26, 55, 96, 0.88);\n}\n\n/* .ant-input {\n  padding: 9px 14px;\n  border: 1px solid #d0d5dd;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);\n}\n.ant-input.ant-input-sm {\n  padding: 4px 8px;\n}\n.ant-input::placeholder,\n.ant-select .ant-select-selection-placeholder {\n  color: #667085;\n} */\n.ant-layout {\n  background: transparent;\n}\n\n.ant-layout main {\n  padding: 40px;\n}\n\n.ant-layout-sider {\n  height: max-content;\n  min-height: 100vh;\n  border-right: 1px solid #eaecf0;\n  padding: 30px 20px;\n  position: sticky !important;\n  top: 0;\n}\n\n.anychart-credits {\n  display: none;\n}\n\n/* .ant-menu-inline .ant-menu-item {\n  height: 40px;\n  line-height: 40px;\n} */\n.ant-menu {\n  font-size: 14px;\n  padding: 16px 12px;\n}\n\n.ant-menu-light.ant-menu-root.ant-menu-inline,\n.ant-menu-light.ant-menu-root.ant-menu-vertical {\n  border: none;\n}\n\n.ant-menu-inline .ant-menu-item,\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-inline .ant-menu-submenu-title,\n.ant-menu-vertical .ant-menu-submenu-title {\n  padding-inline: 16px !important;\n}\n\n.ant-menu .ant-menu-item .ant-menu-item-icon+span,\n.ant-menu .ant-menu-submenu-title .ant-menu-item-icon+span,\n.ant-menu .ant-menu-item .anticon+span,\n.ant-menu .ant-menu-submenu-title .anticon+span {\n  margin-left: 8px;\n}\n\n.ant-layout-sider .ant-menu-item {\n  margin-block: 2px !important;\n  height: 30px !important;\n}\n\n.ant-layout-sider .ant-menu-item-group-title {\n  padding: 6px 16px;\n}\n\n/* .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item {\n  padding: 8px 12px;\n} */\n.ant-message-notice {\n  text-align: right;\n  padding-right: 25px;\n  padding-top: 15px;\n}\n\n/* .ant-btn {\n  display: inline-flex;\n  padding: 10px 18px;\n  align-items: center;\n  justify-content: center;\n} */\n.ant-btn-primary {\n  box-shadow: 0 2px 2px rgb(1 9 14 / 15%);\n}\n\n.ant-table-cell-product+.ant-table-cell-product {\n  border-top: 1px solid #e8e8e8;\n}\n\n.ant-table-cell .ant-btn {\n  height: auto;\n  font-size: 12px;\n  padding: 4px 10px;\n  /* padding: 0px 8px; */\n  border-radius: 6px;\n}\n\n/* .ant-table-cell a:hover {\n  text-decoration: underline;\n} */\n\n.ant-btn [class^=\"ri-\"],\n.ant-btn [class*=\" ri-\"] {\n  display: inline-block;\n  margin-right: 3px;\n}\n\n.ant-btn.ant-btn-sm {\n  font-size: 12px;\n  height: 30px;\n}\n\n.ant-input-affix-wrapper .ant-input-prefix {\n  margin-right: 12px;\n  color: #667085;\n}\n\n.ant-table-wrapper:not(.table-inner) .ant-table {\n  border: 1px solid #d0d5dd;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);\n  border-radius: 8px;\n  overflow: auto;\n}\n\n.ant-table-wrapper.table-inside-card .ant-table {\n  border: none;\n  box-shadow: none;\n  /* border-radius: 0; */\n  margin-top: 1px;\n  border-start-start-radius: 0;\n  border-start-end-radius: 0;\n}\n\n.ant-table-wrapper.table-inside-card .ant-table-container table>thead>tr:first-child>*:first-child {\n  border-start-start-radius: 0;\n}\n\n.ant-table-wrapper.table-inside-card .ant-table-container table>thead>tr:first-child>*:last-child {\n  border-start-end-radius: 0;\n}\n\n.table-inside-card .ant-table-cell {\n  padding: 8px 12px !important;\n}\n\n.expand-warehouse-table .ant-table {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.profile-details-card {\n  border: 1px solid #e8e8e8 !important;\n}\n\n.profile-details-card .ant-card-body {\n  /* padding: 2rem 2.25rem; */\n  border-radius: 12px;\n}\n\n.profile-details-card .ant-card-body .title {\n  color: #030229;\n  font-weight: 500;\n  /* font-size: 16px; */\n}\n\n.status-tag {\n  padding: 4px 10px;\n  font-size: 0.8rem;\n  font-weight: normal;\n}\n\n.profile-details-card .details {\n  color: #030229;\n  font-weight: 400;\n  /* font-size: 16px; */\n}\n\n.title {\n  color: rgba(26, 55, 96, 0.88);\n  font-weight: 600;\n  /* font-size: 16px; */\n}\n\n.details {\n  color: #99a1b7;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.text-030229 {\n  color: #030229;\n}\n\n.text-03022903 {\n  color: #0302294d;\n}\n\n.card-title-custom .ant-card-head-title {\n  /* color: #030229; */\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.card-title-custom .ant-card-body {\n  border-radius: 12px;\n}\n\n.card-title-custom .ant-card {\n  border: 1px solid #e8e8e8;\n}\n\n.card-title-custom {\n  /* padding: 13px; */\n  border-radius: 12px;\n  border: 1px solid #e8e8e8 !important;\n}\n\n.ant-tabs-tab-btn {\n  /* font-size: 16px; */\n  color: rgba(26, 55, 96, 0.88);\n}\n\n.tabs-custom .status-icon-box {\n  width: 50px;\n  height: 50px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.tabs-custom .vendor-po-title {\n  color: #4f4e6a;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 2rem;\n  margin-bottom: 0;\n}\n\n.tabs-custom .vendor-po-desc {\n  color: #4f4e6a;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.5rem;\n}\n\n.background-5B93FF {\n  background-color: #eff4ff;\n}\n\n.background-FFF7E1 {\n  background-color: #ffd56b3f;\n}\n\n.background-FFFBF9 {\n  background-color: #ff906b3a;\n}\n\n.border-bottom {\n  border-bottom: 0.5px solid #03022919;\n}\n\n/* customer details css end */\n.ant-row {\n  width: 100%;\n}\n\n.ant-steps-vertical .ant-steps-item {\n  padding-bottom: 50px;\n}\n\n.mt40 {\n  margin-top: 40px !important;\n}\n\n.mt6 {\n  margin-top: 6px;\n}\n\n.mt8 {\n  margin-top: 8px;\n}\n\n.mt10 {\n  margin-top: 10px;\n}\n\n.mt16 {\n  margin-top: 16px;\n}\n\n.mt20 {\n  margin-top: 20px;\n}\n\n.mt24 {\n  margin-top: 24px;\n}\n\n.mt30 {\n  margin-top: 30px;\n}\n\n.mt-2 {\n  margin-top: 2px;\n}\n\n.mb-9 {\n  margin-bottom: 9px;\n}\n\n.mb0 {\n  margin-bottom: 0 !important;\n}\n\n.mb28 {\n  margin-bottom: 28px;\n}\n\n.mb24 {\n  margin-bottom: 24px;\n}\n\n.mb16 {\n  margin-bottom: 16px;\n}\n\n.mb8 {\n  margin-bottom: 8px;\n}\n\n.mb2 {\n  margin-bottom: 2px;\n}\n\n.me4 {\n  margin-right: 12px;\n}\n\n.me1 {\n  margin-right: 4px;\n}\n\n.my10 {\n  margin: 10px 0;\n}\n\n.mx16 {\n  margin: 0 16px;\n}\n\n.mx26 {\n  margin: 0 26px;\n}\n\n.pt10 {\n  padding-top: 10px;\n}\n\n.pb16 {\n  padding-bottom: 16px;\n}\n\n.pb24 {\n  padding-bottom: 24px;\n}\n\n.p-4 {\n  padding: 4px;\n}\n\n.borderBottomDotted {\n  border-bottom: 1px dotted;\n}\n\n.linkHover:hover {\n  text-decoration: underline;\n}\n\n.borderBottom-ebebeb {\n  border-bottom: 1px solid #ebebeb;\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.fontWeight600 {\n  font-weight: 600;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.align-items-center {\n  align-items: center;\n}\n\n.justify-content-center {\n  justify-content: center;\n}\n\n.justify-content-between {\n  justify-content: space-between;\n}\n\n.d-none {\n  display: none;\n}\n\n.d-block {\n  display: block;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.height-100 {\n  height: 100%;\n}\n\n.grid {\n  display: grid;\n}\n\n.grid-cols-4 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.grid-cols4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.gap30 {\n  gap: 30px;\n}\n\n.mandatory-sign-mark::after {\n  display: inline-block;\n  margin-inline-end: 4px;\n  color: #ff4d4f;\n  font-size: 13px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: \"*\";\n  margin-left: 4px;\n}\n\n.login-container {\n  min-width: 100vw;\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  background-color: #fafafa;\n  align-items: center;\n  /* background-color: #a099ff;\n  background-image: radial-gradient(at 48% 74%,\n      hsla(253, 90%, 67%, 1) 0px,\n      transparent 50%),\n    radial-gradient(at 85% 24%, hsla(269, 76%, 75%, 1) 0px, transparent 50%),\n    radial-gradient(at 55% 58%, hsla(39, 62%, 65%, 1) 0px, transparent 50%),\n    radial-gradient(at 85% 4%, hsla(262, 88%, 74%, 1) 0px, transparent 50%),\n    radial-gradient(at 10% 1%, hsla(184, 84%, 60%, 1) 0px, transparent 50%),\n    radial-gradient(at 39% 5%, hsla(13, 83%, 78%, 1) 0px, transparent 50%),\n    radial-gradient(at 51% 9%, hsla(288, 71%, 77%, 1) 0px, transparent 50%); */\n}\n\n.login-card {\n  width: 100%;\n  margin-top: 50px;\n  border: 1px solid #e3e6e9;\n  padding: 10px;\n  border-radius: 10px;\n  background-color: #fff;\n}\n\n.login-card .logo {\n  width: 180px;\n}\n\n.sidebar-custom-wrap {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n}\n.sidebar-custom-wrap .ant-menu {\n  margin-top: 16px;\n}\n  \n\n.header-user-card-container {\n  border-radius: 6px;\n\n  padding: 5px 10px;\n}\n\n.header-user-card {\n  /* border: 1px solid #d0d5dd;  */\n  border-radius: 8px;\n  /* padding: 10px; */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.user-details {\n  max-width: 110px;\n}\n\n.user-details-wrap {\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 8px;\n  align-items: center;\n}\n\n.user-details-name {\n  font-size: 12px;\n  /* color: #1a3760; */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: bold;\n}\n\n.user-details-email {\n  font-size: 10px;\n  /* color: #1a3760; */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.page-header-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  /* padding-left: 16px;\n  padding-right: 16px; */\n  /* padding-left: 8px;\n  padding-right: 10px; */\n  padding-left: 7px;\n  padding-right: 17px;\n  gap: 16px;\n}\n\n.page-header-wrapper .page-header-title {\n  font-size: 24px;\n  font-weight: bold;\n  text-wrap: nowrap;\n}\n\n.page-header-wrapper .page-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.search-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 350px;\n}\n\n.card-checkbox .ant-checkbox-wrapper {\n  border-radius: 8px;\n  border: 1px solid #d0d5dd;\n  padding: 15px 28px 15px 10px;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.card-checkbox .ant-checkbox-wrapper .ant-checkbox {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n}\n\n.card-checkbox .ant-checkbox-wrapper .ant-checkbox .ant-checkbox-inner,\n.card-checkbox .ant-checkbox-checked:after {\n  border-radius: 100%;\n}\n\n.card-checkbox .ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-checked) .ant-checkbox-inner {\n  border-color: transparent;\n}\n\n.card-checkbox .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {\n  background-color: #e6f4ff;\n  border-color: #1677ff;\n  border-width: 2px;\n  padding: 14px 27px 14px 9px;\n  /* border-width: 2px; */\n}\n\n.report_type_checkboxes .ant-checkbox-wrapper {\n  padding: 15px 28px 15px 28px;\n}\n\n.report_type_checkboxes .ant-checkbox+span {\n  width: 100%;\n  text-align: center;\n}\n\n.report_type_checkboxes .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {\n  padding: 14px 27px 14px 27px;\n}\n\n.marketplace-region {\n  color: #8996a9;\n}\n\n.antd-table-filter-dropdown {\n  padding: 15px 10px;\n  min-width: 200px;\n  display: flex;\n  justify-content: center;\n}\n\n.appplied-filter-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.applied-filter-tag {\n  font-size: 10px;\n  font-weight: 400;\n}\n\n.applied-filter-value {\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.applied-filters-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  flex-grow: 1;\n}\n\n.applied-filter-wrap {\n  padding: 8px;\n  background-color: #ffffff;\n  color: #132237;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height: auto;\n  border: 1px solid #e3e6e9;\n}\n\n.applied-filter-wrap>span {\n  cursor: pointer;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.applied-filter {\n  font-weight: bold;\n}\n\n.applied-filter>span {\n  font-size: 10px;\n  font-weight: normal;\n  margin-right: 10px;\n}\n\n.applied-filter-wrap .applied-filter-remove {\n  display: flex;\n  align-items: flex-start;\n  margin-left: 5px;\n  cursor: pointer;\n}\n\n.detail-block {\n  line-break: anywhere;\n}\n\n.detail-block>label,\n.detail-block>span {\n  display: block;\n}\n\n.detail-block>label {\n  font-size: 14px;\n  color: #667085;\n  margin-bottom: 3px;\n}\n\n.detail-block>span {\n  font-size: 18px;\n  font-weight: bold;\n  display: inline-block;\n}\n\n.marketplace-detail-card,\n.report-type-wrapper {\n  border-radius: 8px;\n  border: 1px solid #d0d5dd;\n  padding: 15px 28px 15px 10px;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  align-items: center;\n  position: relative;\n  font-weight: normal;\n  text-align: center;\n}\n\n.report-type-wrapper {\n  font-size: 14px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding: 18px 20px;\n  width: 100%;\n  white-space: nowrap;\n}\n\n.table-tag .ant-alert {\n  display: inline-flex;\n  padding: 4px 8px;\n}\n\n.table-tag .ant-alert .ant-alert-content {\n  font-size: 12px;\n}\n\n.product-image-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.product-image-wrapper {\n  width: 102px;\n  height: 102px;\n  padding: 8px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n}\n\n.product-image-wrapper-sm {\n  width: 50px;\n  height: 50px;\n  padding: 5px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n}\n\n.product-title {\n  font-size: 16px;\n}\n\n.product-price {\n  color: #1677ff;\n}\n\n.detail-block>label {\n  /* font-weight: 600; */\n}\n\n.detail-block ul {\n  padding-inline-start: 16px;\n  list-style-type: decimal;\n}\n\n.detail-block ul li {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.pd-identifier {\n  color: #667085;\n  margin-bottom: 10px;\n  display: block;\n}\n\n.pd-product-name {\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.ant-descriptions-item-content ul {\n  padding-left: 18px;\n}\n\n.pd-status-wrap {\n  display: inline-block;\n  margin-bottom: 20px;\n}\n\n.amazon-serach-modal-search .ant-input-group .ant-input-group-addon .ant-select {\n  margin: 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px 0 0 8px;\n  border-right: 0px;\n}\n\n.amazon-serach-modal-search .ant-input-group .ant-input-group-addon {\n  padding: 0;\n  border: 0;\n}\n\n.amazon-serach-modal-search .ant-input-group .ant-input {\n  height: 46px;\n}\n\n.amazon-serach-modal-search .ant-input-group .ant-input-group-addon .ant-btn {\n  border-radius: 0 8px 8px 0;\n  border-left: 0;\n  height: 46px;\n}\n\n.read-more-btn {\n  background-color: transparent;\n  border: none;\n  color: #8996a9;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n@media all and (min-width: 576px) {\n  .login-card {\n    width: 480px;\n    padding: 40px;\n    padding-bottom: 60px;\n  }\n}\n\n.ant-checkbox-wrapper {\n  align-items: center;\n}\n\n.ant-form-item-required::before {\n  order: 1;\n  margin-right: 0;\n  margin-left: 4px;\n}\n\n.ant-list-bordered {\n  overflow: hidden;\n}\n\n.prdouct-info-btn {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.password-field label {\n  width: 100%;\n}\n\n.password-field .password-field-label {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ant-form-item .ant-form-item-label>label::after {\n  display: none;\n}\n\n.password-field .ant-form-item-extra {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translateY(-100%);\n}\n\n.ant-layout .ant-layout-sider-light {\n  /* background-color: #ffffff; */\n  background-color: #001529;\n  padding: 0;\n  /* border: 0; */\n}\n\n.ant-drawer-body, .ant-drawer-header {\n   background-color: #001529;\n}\n\n.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper,\n.ant-layout-header {\n  height: 56px;\n}\n\n.ant-layout-header {\n  position: sticky;\n  top: 0;\n  display: flex;\n  align-items: center;\n  line-height: 1.25;\n  padding: 0 16px;\n  z-index: 1;\n  border-bottom: 1px solid #eaecf0;\n}\n\n.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper {\n  padding: 5px 16px;\n}\n\n.ant-layout .ant-layout-sider-light .sidebar-logo-wrapper img {\n  max-height: 100%;\n  margin: 0;\n}\n\n.ant-layout-sider .ant-menu-item {\n  font-weight: 500;\n}\n\n.ant-pagination .ant-pagination-item {\n  border-radius: 6px;\n}\n\n.ant-card {\n  box-shadow: rgba(26, 26, 26, 0.07) 0px 1px 0px 0px;\n  border: 1px solid rgb(204, 204, 204, 0.5);\n}\n\n.ant-picker {\n  width: 100%;\n}\n\n.ant-list-bordered {\n  background-color: #fff;\n}\n\n.address-make-default-btn {\n  opacity: 0;\n  transition-duration: 0.3s;\n}\n\n.ant-collapse-header:hover .address-make-default-btn {\n  opacity: 1;\n}\n\n.ant-upload-list {\n  margin-top: 8px;\n}\n\n.ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item-container,\n.ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload.ant-upload-select {\n  width: 80px;\n  height: 80px;\n}\n\n.ant-upload-wrapper .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item {\n  border-radius: 8px;\n  padding: 6px;\n}\n\n.ant-upload-wrapper .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item .ant-upload-list-item-thumbnail {\n  border-radius: 4px;\n}\n\n.ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item::before {\n  width: calc(100% - 0px);\n  height: calc(100% - 0px);\n  top: 0;\n  left: 0;\n  border-radius: 6px;\n}\n\n.ant-upload-wrapper .ant-upload-list .ant-upload-list-item .ant-upload-list-item-actions .ant-upload-list-item-action.ant-btn-sm {\n  padding: 10px 5px;\n  width: auto;\n  height: auto;\n  background-color: #ffffff29;\n  border: 1px solid #ffffff50;\n}\n\n.ant-menu-sub.ant-menu-inline .ant-menu-item {\n  padding-left: 38px !important;\n}\n\n.form-remove-btn {\n  margin-top: 32px;\n  font-size: 18px;\n}\n\n.ql-toolbar.ql-snow {\n  border-radius: 8px 8px 0 0;\n  padding: 5px 3px;\n  font-family: \"Inter\", sans-serif;\n}\n\n.ql-toolbar.ql-snow .ql-picker-label {\n  border-radius: 5px;\n}\n\n.ql-toolbar.ql-snow .ql-picker-options {\n  border-radius: 8px;\n}\n\n.ql-container {\n  font-family: \"Inter\", sans-serif;\n}\n\n.ql-container.ql-snow {\n  border-radius: 0 0 8px 8px;\n}\n\n.ql-editor {\n  min-height: 5rem;\n  max-height: 30rem;\n  overflow-y: auto;\n}\n\n.hamburger-responsive {\n  /* border: 1px solid #4c535e; */\n  background-color: #2b2f35;\n  height: 37px;\n  width: 37px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 18px;\n}\n\n.nav-logo-responsive {\n  /* max-height: 37px; */\n  width: auto;\n}\n\n.form-tab-section {\n  margin: 24px 0px;\n}\n\n.form-tab-section .ant-tabs-nav {\n  margin-bottom: 0px;\n  /* z-index: 1; */\n  /* border-bottom: 1px solid rgb(204, 204, 204, 0.5); */\n}\n\n.form-tab-section .ant-tabs-tabpane>.ant-card {\n  background: transparent;\n  border-top-right-radius: 0%;\n  border-top-left-radius: 0%;\n  /* border-top: none; */\n  position: relative;\n  /* z-index: -1; */\n}\n\n.form-tab-section .ant-tabs-tab-active {\n  background: #f3f6f9 !important;\n  border: 1px solid rgb(204, 204, 204, 0.5) !important;\n  border-bottom: none !important;\n}\n\n.form-tab-section .ant-tabs-nav {\n  position: sticky;\n  top: 56px;\n}\n\n.form-tab-section .ant-tabs-top>.ant-tabs-nav::before {\n  border-bottom-color: rgb(204, 204, 204, 0.5);\n}\n\n.form-tab-section .ant-tabs-nav-wrap {\n  background: #f3f6f9;\n}\n\n.form-tab-section .ant-tabs-tab-active::after {\n  position: absolute;\n  right: 0;\n  left: 0;\n  bottom: -4px;\n  /* border-bottom: 3px solid #172539; */\n  border: 3px solid #f3f6f9;\n  content: \"\";\n  /* z-index: 2; */\n}\n\n.header-user-card-container {\n  cursor: pointer;\n}\n\n.ant-menu-sub .ant-menu-item {\n  height: 28px;\n  line-height: 28px;\n}\n\n/* .ant-menu-submenu-open {\n  background-color: rgba(229, 240, 255, 0.5);\n} */\n\n.ant-menu-submenu-open {\n  background-color: #ebeff480;\n}\n\n.ant-menu-inline-collapsed .ant-menu-item-group-title {\n  opacity: 0;\n  /* height: ; */\n}\n\n.ant-menu-item-group:not(:first-child) {\n  margin-top: 0px;\n}\n\n.sidebar-responsive {\n  font-size: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  padding: 0;\n  border: 1px solid #eee;\n}\n\n.ant-menu-light.ant-menu-root.ant-menu-inline {\n  overflow-y: auto;\n}\n\n.table-cell-link {\n  font-weight: 700;\n}\n\n/* .table-cell-link:hover {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n} */\n\n/* .table-cell-product-image {\n  border: 1px solid rgba(235, 235, 235, 1);\n  min-height: 40px;\n  min-width: 40px;\n  object-fit: cover;\n  border-radius: 6px;\n} */\n\n.table-cell-product-image {\n  border: 1px solid rgba(235, 235, 235, 1);\n  min-height: 40px;\n  min-width: 40px;\n  object-fit: contain;\n  border-radius: 6px;\n  aspect-ratio: 1 / 1;\n}\n\n.ant-table-cell-with-append {\n  /* display: flex; */\n  align-items: center;\n}\n\n.ant-table-wrapper:not(.table-inner) .ant-table-row-indent+.ant-table-row-expand-icon {\n  border-color: #1a3760e0;\n  margin-top: 12px;\n}\n\n.ant-table-wrapper.expand-without-image .ant-table-row-indent+.ant-table-row-expand-icon {\n  display: none;\n}\n\n.ant-tabs-card>.ant-tabs-nav .ant-tabs-tab {\n  background: rgb(26 55 96 / 7%);\n  border: none;\n}\n\n.ant-tabs>.ant-tabs-nav .ant-tabs-nav-add {\n  border: none;\n  background: rgb(26 55 96 / 7%);\n}\n\n.purchase-order-table {\n  margin-top: 12px;\n}\n\n.purchase-order-table.ant-table-wrapper .ant-table {\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.purchase-order-table.ant-table-wrapper .ant-table-container,\n.purchase-order-table.ant-table-wrapper .ant-table-container table,\n.purchase-order-table.ant-table-wrapper .ant-table-container table>thead>tr:first-child>*:first-child,\n.purchase-order-table.ant-table-wrapper .ant-table-container table>thead>tr:first-child>*:last-child {\n  border-radius: 0;\n}\n\n.purchase-order-table .ant-table-cell {\n  vertical-align: top;\n}\n\n.recieve-order-progress .ant-progress .ant-progress-success-bg {\n  background-color: rgba(41, 132, 90, 1);\n}\n\n.recieve-order-progress .ant-progress-bg {\n  background-color: rgba(181, 38, 11, 1);\n}\n\n.inventory-unavaible-card .ant-card-body {\n  padding: 4px;\n}\n\n.inventory-unavaible-card .ant-card-head {\n  padding: 4px;\n  min-height: auto;\n}\n\n.order-user-card .ant-card {\n  border: 0px;\n  box-shadow: none;\n  padding: 0;\n  border-radius: 0;\n}\n\n.order-user-card .ant-card:hover {\n  border: 0px;\n  box-shadow: none;\n  padding: 0;\n  border-radius: 0;\n}\n\n.order-user-card .ant-card .ant-card-body {\n  padding: 8px;\n  border-radius: 0;\n}\n\n.order-user-link-card .ant-card {\n  border: 0px;\n  box-shadow: none;\n  padding: 0;\n  border-radius: 0;\n}\n\n.order-user-link-card .ant-card:hover {\n  border: 0px;\n  box-shadow: none;\n  padding: 0;\n  border-radius: 0;\n}\n\n.order-user-link-card .ant-card .ant-card-body {\n  padding: 8px;\n  border-radius: 0;\n}\n\n.collection-product-table .ant-table-container .ant-table-thead {\n  display: none;\n}\n\n.collection-product-table {\n  margin-top: 24px;\n}\n\n.product-variant-badge .ant-badge.ant-badge-status .ant-badge-status-dot {\n  width: 6px;\n  height: 6px;\n}\n\n.comment-section .comment-section-input {\n  border: none;\n  padding-left: 0;\n}\n\n.comment-section .ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input:focus,\n.comment-section .ant-input:focus {\n  box-shadow: none;\n}\n\n.comment-section .ant-card-small>.ant-card-body {\n  padding: 0;\n}\n\n.comment-section .comment-section-top {\n  padding: 12px;\n}\n\n.comment-section .comment-section-bottom {\n  padding: 12px;\n  background-color: #f3f6f9;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.comment-section-block {\n  position: absolute;\n  inset-block-start: 0px;\n  inset-inline-start: 4px;\n  height: 40px;\n  border-inline-start: 2px solid rgba(5, 5, 5, 0.06);\n}\n\n.log-inventory_received .ant-table-wrapper:not(.table-inner) .ant-table {\n  border: none;\n  box-shadow: none;\n  border-radius: 0px;\n  overflow: auto;\n}\n\n.log-inventory_received .ant-table-wrapper .ant-table-thead>tr>th,\n.log-inventory_received .ant-table-wrapper .ant-table-thead>tr>td {\n  position: relative;\n  color: rgba(26, 55, 96, 0.88);\n  font-weight: 600;\n  text-align: start;\n  background: transparent;\n  border-bottom: none;\n}\n\n.log-inventory_received .ant-table-wrapper .ant-table {\n  background: transparent;\n}\n\n.log-inventory_received .ant-table-wrapper .ant-table-tbody>tr>td {\n  border-bottom: none;\n}\n\n.log-inventory_received .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n  background-color: transparent;\n}\n\n.log-inventory_received .log-inventory_received-description:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.log-inventory_received .log-inventory_received-arrow:hover {\n  cursor: pointer;\n}\n\n.log-inventory_received .log-inventory_received-description-container {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mt3 {\n  margin-top: 3px;\n}\n\n/* cms page form css start */\n.dashed-border {\n  /* border:1px dashed #8996a9; */\n  margin-top: 20px;\n\n  border-top: 1px dashed #8996a9;\n}\n\n.form-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333333;\n  margin-bottom: 8px;\n}\n\n.form-description {\n  font-size: 14px;\n  font-weight: 400;\n  color: #666666;\n}\n\n.form-box {\n  background-color: white;\n  padding: 32px;\n}\n\n/* cms page form css end */\n\n/* sticky footer css start */\n.sticky-footer {\n  position: sticky;\n  bottom: 0;\n  backdrop-filter: blur(9px);\n  background-color: rgba(243, 244, 246, 0.1);\n  text-align: right;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  margin-left: -2rem;\n  margin-right: -2rem;\n  z-index: 999;\n}\n\n.sticky-footer-padding {\n  position: sticky;\n  bottom: 0;\n  backdrop-filter: blur(9px);\n  background-color: rgba(243, 244, 246, 0.1);\n  text-align: right;\n  padding: 1.5rem 3.2rem;\n  /* padding-left: 2rem;\n  padding-right: 2rem; */\n  margin-left: -2rem;\n  margin-right: -2rem;\n}\n\n.ant-card .ant-card-actions>li {\n  margin: 4px 0;\n}\n\n.ant-card .ant-card-head-title {\n  overflow: visible;\n}\n\n.google-places-autocomplete {\n  margin-bottom: 24px;\n}\n\n.google-places-autocomplete div[class$=\"control\"]::before {\n  width: 24px;\n  height: 24px;\n  content: \"\";\n  background-image: url(\"https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg\");\n  background-size: 24px 24px;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  pointer-events: none;\n}\n\n.google-places-autocomplete div[class$=\"control\"] {\n  border-width: 1px;\n  border-style: solid;\n  border-color: #d9d9d9;\n  border-radius: 8px;\n  transition: all 0.2s;\n  min-height: 32px;\n  height: auto;\n  padding-left: 32px;\n}\n\n.google-places-autocomplete div[class$=\"indicatorContainer\"] {\n  padding: 6px;\n}\n\n.google-places-autocomplete div[class$=\"Input\"] {\n  margin: 0;\n}\n/* sticky footer css end */\n\n/* filter section start */\n.filter-section {\n  margin: 16px 0px;\n}\n\n.filter-section .ant-card .ant-card-body {\n  padding: 4px;\n}\n\n.filter-section .ant-btn.ant-btn-sm {\n  padding: 5.5px 8px;\n}\n\n.filter-section .ant-btn.ant-btn-sm.ant-btn-text {\n  padding: 5.5px 12px;\n  font-weight: 600;\n}\n\n.filter-section-head {\n  border-bottom: 1px solid rgb(204, 204, 204, 0.5);\n  padding: 10px 10px 10px 10px;\n}\n\n/* filter section end */\n\n/* Setting start */\n.header-setting .menu-icon-box {\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.header-setting .menu-title {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 2rem;\n  margin-bottom: 0;\n}\n\n.background-ff6b6b3a {\n  background-color: #ff8b8b3a;\n  color: rgb(235 29 29);\n}\n\n.background-6bff6b3a {\n  background-color: #80ff803a;\n  color: #15b41e;\n}\n/* Setting end */\n \n\n/* Dashboard Start */\n/* .dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.dashboard-header .page-title-wrapper .page-header-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #111111e0;\n  margin-bottom: 6px;\n}\n.dashboard-header .page-title-wrapper .page-header-description {\n  font-size: 12px;\n  font-weight: 400;\n  color: #00000073;\n} */\n\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n\n  .page-title-wrapper {\n    .page-header-title {\n      font-size: 20px;\n      font-weight: 600;\n      color: #111111e0;\n      margin-bottom: 6px;\n    }\n\n    .page-header-description {\n      font-size: 12px;\n      font-weight: 400;\n      color: #00000073;\n    }\n  }\n\n  .dashboard-filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-top: 12px;\n  }\n}\n\n.dashboard-header .ant-select,\n.dashboard-header .ant-picker {\n  min-width: 120px;\n  max-width: 240px;\n}\n\n@media (max-width: 768px) {\n  .dashboard-header {\n    flex-direction: column;\n    align-items: flex-start;\n\n    .dashboard-filters {\n      width: 100%;\n      justify-content: flex-start;\n    }\n  }\n}\n\n.creative-gallery {\n  display: flex;\n  gap: 8px;\n  /* flex-wrap: wrap; */\n  align-items: center;\n}\n\n.creative-img {\n  border:1px solid #ebebeb;\n  border-radius: 12px;\n  object-fit: cover;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.creative-img:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.map-header {\n  position: absolute;\n  z-index: 1;\n  background: #fff;\n  padding: 0px 12px 8px 0px;\n  border-bottom-right-radius: 10px;\n  top: 16px;\n}\n\n\n.dashboard-container .ant-table-wrapper:not(.table-inner) .ant-table {\n  border: 0px solid #d0d5dd;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);\n  border-radius: 8px;\n  overflow: auto;\n}\n\n.highlighted-row {\n  background-color: #e6f7ff !important;\n  transition: background-color 0.3s ease;\n}\n\n.gm-style-iw-chr {\n display: none !important;\n}\n\n.ant-image-preview-switch-right,\n.ant-image-preview-switch-left,\n.ant-image-preview-close {\n    color: #001529;\n    background: #ffffff;\n}\n\n.ant-image-mask-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n/* .ant-image-mask-info::after {\n  content: none !important;\n}\n\n.ant-image-mask-info > span + span {\n  display: none !important;\n} */\n\n.brand-scroll-container::-webkit-scrollbar {\n  height: 5px; /* Smaller height for horizontal scroll */\n}\n\n.brand-scroll-container::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 4px;\n}\n\n.brand-scroll-container::-webkit-scrollbar-track {\n  background: #f0f0f0;\n}\n\n\n/* Dashboard End */\n\n@media all and (min-width: 1200px) {\n  .header-user-card-container {\n    min-width: 180px;\n    background-color: #f7f7f7;\n  }\n}\n\n@media all and (max-width: 1200px) {\n  .nav-logo-responsive {\n    max-height: 50px;\n    width: auto;\n  }\n}\n\n@media all and (max-width: 767px) {\n  .search-wrapper {\n    min-width: 300px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
